export enum DataSource {
    ENTITY = 'Entity',
    FLOWABLE = 'Flowable',
}
